import {Component, Input, OnInit} from "@angular/core";

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {

  @Input() name: string;
  @Input() description: string;
  @Input() redirectUrl: string;
  @Input() logoFile: string;
  public ngOnInit(): void {}

  openUrlInNewTab(url: string): void {
    if (url.length > 0) {
      window.open(url, '_blank');
    }
  }
}
